import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MuacComponent} from './muac.component';

@NgModule({
    declarations: [MuacComponent],
    imports: [
        CommonModule
    ],
    exports: [
        MuacComponent
    ],
})
export class MuacModule {
}
